
    // ============================================================================================

    /**
     * @description shopify redesign footer
     * ============================================================================================
     */
    export default {
        name: "FooterFour",
        data() {
            return {
                date: new Date(),
                footerItems: [
                    {title: 'privacy_policy', href: '/privacy-policy'},
                    {title: 'terms_and_conditions', href: '/terms-and-conditions'},
                    // {title: 'terms_and_conditions_usa', href: '/terms-and-conditions-us'},
                    // {title: 'terms_and_conditions_buyer_usa', href: '/terms-and-conditions-buyer-us'},
                ],
            }
        },
    }
